export const faqItems = [
  {
    id: 'faq-1',
    question: '免费在线成网站真的完全免费吗？',
    answer: '是的，我们的免费在线成网站平台提供完全免费的建站服务。您可以零成本创建完整的网站，包括所有核心功能：模板选择、内容编辑、SEO优化、响应式设计等。我们致力于让每个人都能够轻松拥有自己的网站。',
  },
  {
    id: 'faq-2',
    question: '不会编程也能使用免费在线成网站吗？',
    answer: '当然可以！免费在线成网站平台专为零基础的普通用户设计。您无需任何编程知识，通过直观的拖拽式操作和AI智能生成功能，就能快速创建专业网站。整个过程就像操作一个高级版Word文档一样简单。',
  },
  {
    id: 'faq-3',
    question: '建好的网站可以在手机上正常显示吗？',
    answer: '完全没问题！所有免费在线成网站平台上的模板都采用了响应式设计，会自动适配手机、平板和电脑等不同屏幕尺寸。您的网站在任何设备上都能呈现出最佳效果，给访客良好的浏览体验。',
  },
  {
    id: 'faq-4',
    question: '免费在线成网站支持哪些类型的网站？',
    answer: '我们的免费在线成网站平台支持几乎所有常见类型的网站：企业官网、个人博客、电商商城、作品集展示、餐饮美食网站、教育培训网站、活动页面、落地页等。平台提供了对应各行业的专业模板，满足不同场景需求。',
  },
  {
    id: 'faq-5',
    question: '免费建的网站能绑定自己的域名吗？',
    answer: '可以的！通过免费在线成网站平台建好网站后，您可以绑定自己购买的独立域名（如 www.yourcompany.com），让网站看起来更加专业。域名绑定操作简单，按照平台指引几分钟即可完成配置。',
  },
  {
    id: 'faq-6',
    question: '网站的SEO优化效果怎么样？',
    answer: '免费在线成网站平台内置了强大的SEO优化工具，包括自动生成站点地图、自定义TDK（标题、描述、关键词）、结构化数据标记、页面速度优化等功能。许多用户反映，使用我们平台建的网站在百度和Google上都有不错的搜索排名。',
  },
  {
    id: 'faq-7',
    question: '网站数据安全吗？会不会丢失？',
    answer: '您的网站数据非常安全。免费在线成网站平台采用企业级数据存储方案，所有数据都有自动备份机制。同时使用HTTPS加密传输保障数据安全，您可以放心使用。',
  },
];

export const siteFeatures = [
  {
    id: 'feat-1',
    icon: 'ri-magic-line',
    title: '一键智能生成',
    description: '只需输入需求，AI自动生成完整网站结构和内容，省去繁琐的设计和排版工作。',
  },
  {
    id: 'feat-2',
    icon: 'ri-money-cny-circle-line',
    title: '真正零成本',
    description: '所有核心功能永久免费，不限制页面数量，不强制显示广告，让你的网站保持专业形象。',
  },
  {
    id: 'feat-3',
    icon: 'ri-layout-masonry-line',
    title: '海量精美模板',
    description: '数百款由专业设计师打造的模板，覆盖企业、博客、电商、餐饮等各行业需求。',
  },
  {
    id: 'feat-4',
    icon: 'ri-smartphone-line',
    title: '全终端适配',
    description: '所有模板响应式设计，自动适配手机、平板、电脑，在任何设备上都有最佳浏览体验。',
  },
  {
    id: 'feat-5',
    icon: 'ri-search-eye-line',
    title: '内置SEO优化',
    description: '自动生成站点地图、自定义TDK、结构化数据标记，帮助你的网站在搜索引擎中获得更好排名。',
  },
  {
    id: 'feat-6',
    icon: 'ri-refresh-line',
    title: '持续更新迭代',
    description: '平台功能不断更新，模板库持续扩充，确保你的网站始终使用最新最好的技术和设计。',
  },
];

export const stats = [
  { value: '50万+', label: '已创建网站' },
  { value: '98%', label: '用户满意度' },
  { value: '300+', label: '精美模板' },
  { value: '24/7', label: '技术支持' },
];